'use client'

export interface VerticalSpacingClientProps {
  height: number
  mobileHeight: number
  tabHeight?: number
  notebookHeight?: number
}

export default function VerticalSpacingClient({
  height,
  mobileHeight,
  tabHeight,
  notebookHeight,
}: VerticalSpacingClientProps) {
  return (
    <>
      <div className='w-full block sm:hidden' style={{ height: `${mobileHeight}px` }} />
      {tabHeight && <div className='w-full hidden sm:block md:hidden' style={{ height: `${tabHeight}px` }} />}
      {notebookHeight && (
        <div className='w-full hidden md:block lg:hidden' style={{ height: `${notebookHeight}px` }} />
      )}
      <div className='w-full hidden lg:block' style={{ height: `${height}px` }} />
    </>
  )
}